import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	['headerText', 'bodyText', 'ctaMessage', 'closeLabel', 'imageAltText']
> = defineContent({
	default: {
		headerText: {
			id: 'post-office.confluence-resurrected-user-welcome-back.next-best-action.header',
			defaultMessage: 'Welcome back',
			description: 'Title shown when displaying the welcome back nudge for resurrected users.',
			role: 'title',
		},
		bodyText: {
			id: 'post-office.confluence-resurrected-user-welcome-back.body',
			defaultMessage: 'Catch up on the top discussions and highlights from your team.',
			description: 'Body for confluence side nav welcome back nudge for resurrected users.',
			role: 'description',
		},
		ctaMessage: {
			id: 'post-office.confluence-resurrected-user-welcome-back.cta',
			defaultMessage: "See what's popular",
			description: 'CTA button text for the welcome back nudge for resurrected users.',
		},
		closeLabel: {
			id: 'post-office.confluence-resurrected-user-welcome-back.close',
			defaultMessage: 'Close',
			description: 'Label for the close icon that is represented by an X',
		},
		imageAltText: {
			id: 'post-office.confluence-resurrected-user-welcome-back.image-alt',
			defaultMessage: 'Two hearts overlapped with each other',
			description: 'Alternate text for picture of two hearts',
		},
	},
});
